/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */

import TaskMonitor from './index';

/**
 * decorators函数，支持类的方法调用
 */
export function performanceMark(target: any, key: PropertyKey, descriptor: any) {
    addmark(target, key, descriptor);
}

// 修改现有描述符
function addmark(target: any, key: PropertyKey, descriptor: any): any {
    if (descriptor.writable && descriptor.value && !target[`${String(key)}-performanceMark`]) {
        const func = descriptor.value; // 先获取之前的函数
        // 修改对应的value
        descriptor.value = function (...args) {
            const className = this.constructor.name;
            let result = undefined;
            TaskMonitor.getInstance().markPerformanceBlock(`⚛ ${className}.${String(key)}`, () => {
                result = func.apply(this, args);
            });
            return result;
        };
        target[`${String(key)}-performanceMark`] = true;
    }
}

export function breadCrumb(target: any, key: PropertyKey, descriptor: PropertyDescriptor) {
    const func = descriptor.value; // 先获取之前的函数
    // 修改对应的value
    descriptor.value = function (...args) {
        const className = this.constructor.name;
        TaskMonitor.getInstance().addBreadCrumb(`⚛ ${className}.${String(key)}`, args);
        const result = func.apply(this, args);
        return result;
    };
}

/**
 * decorators函数，支持类的方法调用
 */
export function stackTrace(target: any) {
    const descriptors: TypedPropertyDescriptor<PropertyDescriptor> = Object.getOwnPropertyDescriptors(target.prototype);
    const descriptorKeys = Object.keys(descriptors);
    descriptorKeys.forEach((key) => {
        if (key === 'constructor' || key.startsWith('_')) return;
        // 获取函数对应的描述符
        const descriptor = descriptors[key]; // Object.getOwnPropertyDescriptor(target.prototype, key);
        if (descriptor) {
            autoMark(target.prototype, key.toString(), descriptor);
        }
    });
}

function autoMark(target: any, key: PropertyKey, descriptor: any) {
    if (descriptor.writable && descriptor.value && !target[`${String(key)}-mark`]) {
        // 生成新的函数，添加耗时统计逻辑
        const callWithMark = function (...arg) {
            const className = this.constructor.name;
            let result = undefined;
            TaskMonitor.getInstance().markOperationBlock(`⚛ ${className}.${String(key)}`, () => {
                result = descriptor.value.apply(this, arg);
            });
            return result;
        };

        // 将修改后的函数重新定义到原型链上
        Object.defineProperty(target, key, {
            ...descriptor,
            value: callWithMark,      // 覆盖描述符重的value
        });
        target[`${String(key)}-mark`] = true;
    }
}

